// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12wUt","colMin":"styles_colMin__1ClcV"};